// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"FieldColumn_fullWidth__1w6-h"};